import axios from "axios";
import { authHeader } from "../utils/authHeader";

const apiUrl = process.env.REACT_APP_API_URL;

export const list = (page, limit, accessToken) => {
  return axios.get(apiUrl + "/user/all/" + page + "/" + limit, {
    headers: authHeader(accessToken),
  });
};

export const get = (id, accessToken) => {
  return axios.get(apiUrl + "/game/" + id, {
    headers: authHeader(accessToken),
  });
};
